/*
 * Buchholz: kill the sub-pixel hairline seam on PDP gallery images.
 *
 * The site container is centered to a fractional CSS pixel (e.g. left: 305.125),
 * so the square main image's edges land between device pixels and the browser
 * blends a faint 1px column of image + page background along the left/right edge.
 *
 * Fix: nudge the gallery viewer so its left edge snaps onto the device-pixel grid.
 * Swiper sizes each slide to an integer CSS width, so once the viewer's left edge
 * is device-aligned, both slide edges paint crisp with no seam. Re-runs on resize.
 */
(function () {
  var VIEWER_SELECTOR = '.product-gallery__viewer';

  function snap(viewer) {
    // Measure the untransformed position, then re-apply the correction.
    viewer.style.transform = 'none';
    var left = viewer.getBoundingClientRect().left;
    var dpr = window.devicePixelRatio || 1;
    var target = Math.round(left * dpr) / dpr;
    var dx = target - left;
    viewer.style.transform = dx ? 'translateX(' + dx + 'px)' : '';
  }

  var rafId = null;
  function snapAll() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      var viewers = document.querySelectorAll(VIEWER_SELECTOR);
      for (var i = 0; i < viewers.length; i++) snap(viewers[i]);
    });
  }

  function init() {
    if (!document.querySelector(VIEWER_SELECTOR)) return;
    snapAll();
    window.addEventListener('resize', snapAll);
    window.addEventListener('load', snapAll);

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(snapAll);
      var viewers = document.querySelectorAll(VIEWER_SELECTOR);
      for (var i = 0; i < viewers.length; i++) ro.observe(viewers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
